import React, { Fragment } from 'react';

import { Grid, TextField } from '@mui/material';
import ChipInput from '../../../ChipInput/ChipInput';
import useTransformStore from '../../useTransformStore';

function FindAndReplace({
  replace,
  onPlaceholderSelected,
  availablePlaceholders,
  withThis,
  index,
}) {
  return (
    <Fragment>
      <Grid item xs={12} className="item-label">
        Replace this
      </Grid>
      <Grid item xs={12} className="input-list-transform">
        <ChipInput
          inputValue={replace}
          onPlaceholderSelected={onPlaceholderSelected}
          placeholders={availablePlaceholders}
          placeholder="Type something or insert a placeholder"
          fullWidth
          onBeforeAdd={chip => {
            useTransformStore.getState().setComponent(chip, index, 'replace');
            return true;
          }}
          onDelete={indexChip => useTransformStore.getState().deleteChip(indexChip, index, 'replace')}
          onFocus={() => useTransformStore.getState().setFocus(index, 'replace')}
        />
      </Grid>
      <Grid item xs={12} className="item-label">
        With this
      </Grid>
      <Grid item xs={12} className="input-list-transform">
        <ChipInput
          placeholders={availablePlaceholders}
          onPlaceholderSelected={onPlaceholderSelected}
          fullWidth
          inputValue={withThis}
          onBeforeAdd={chip => {
            useTransformStore.getState().setComponent(chip, index, 'withThis');
            return true;
          }}
          placeholder="Type something or insert a placeholder"
          onDelete={indexChip => useTransformStore.getState().deleteChip(indexChip, index, 'withThis')}
          onFocus={() => useTransformStore.getState().setFocus(index, 'withThis')}
        />
      </Grid>
    </Fragment>
  );
}

export default FindAndReplace;
